// This function allow to reference async chunks and chunks that the entrypoint depends on
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 792) return "static/chunks/main-c9005007d2a4377d.js";
	if (chunkId === 636) return "static/chunks/pages/_app-7271683e1b997efd.js";
	if (chunkId === 593) return "static/chunks/framework-405aafdba915b920.js";
	if (chunkId === 946) return "static/chunks/946-bdbfb7462a3b0a8e.js";
	if (chunkId === 196) return "static/chunks/196-4bd9fe6e9b5b9ae9.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"21":"0bc71b4665dc09ca","195":"16274d880be50eb6","345":"94063cb4963e5785","483":"193b123a05d5a0e0","515":"2a7827a329f5969a","551":"6f1da23b6905343b","566":"aed4296a36b61807","857":"94b780c1bb7f2fa3","871":"bc49b2d01173ac59","992":"93ae3e5e07dd94d1"}[chunkId] + ".js";
};